<template>
  <main class="wrapper">
    <section class="tabs">
      <button :class = "{tab: true, active: toggleBoiler === true}" @click="clickBoiler(); $router.push('/repair/repairBoiler')">
         Ремонт <br> котла
      </button>
      <button :class = "{tab: true, active: toggleHeatchanger === true}" @click="clickHeatchanger(); $router.push('/repair/repairHeatchanger')">
        Ремонт <br> теплообмен.
      </button>
    </section>
    <transition name="slide-pageTransition" mode="out-in">
      <router-view></router-view>
    </transition>
  </main>
</template>

<script>

  import {ref} from "@vue/reactivity";
  import {useRoute} from 'vue-router'

  export default {
    setup() {
      const router = useRoute()

      let route = router.path
      let toggleBoiler = ref (false)
      let toggleHeatchanger = ref (false)

      if (route === '/repair/repairBoiler') {
        toggleBoiler.value = true
      } else {
        toggleHeatchanger.value =true
      }

      function clickBoiler() {
        toggleBoiler.value = true
        toggleHeatchanger.value = false
      }

      function clickHeatchanger() {
        toggleBoiler.value = false
        toggleHeatchanger.value = true
      }

      return {
        toggleBoiler,
        toggleHeatchanger,
        clickBoiler,
        clickHeatchanger,
      }

    }
  }
</script>

<style scoped>

button {
  border: 0;
}

.tabs {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
}

.wrapper{
  display: flex;
  flex-direction: column;
  align-items: center;
}

h1 {
  text-align: center;
  text-transform: uppercase;
}

@media (min-width: 1400px) {
  .tab {
    width: 20vw;
    font-size: 1.5em;
  }

  .tab.active {
    font-size: 2em;
  }
}

@media (max-width: 1400px) {
  .tab {
    width: 40vw;
    font-size: 1.2em;
  }

  .tab.active {
    font-size: 1.7em;
  }
}

@media (max-width: 400px) {
  .tab {
    width: 50vw;
    font-size: 1.0em;
  }
  .tab.active {
    font-size: 1em;
  }
}

</style>